import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { UiNewButtons } from '~app-ui-new/buttons';

@Component({
	selector: 'menu-clear-button',
	templateUrl: './menu-clear-button.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [TranslocoModule, UiNewButtons],
	host: {
		class: 'block',
	},
})
export class MenuClearButtonComponent {
	public readonly clear$ = output({ alias: 'clear' });

	public clear(): void {
		this.clear$.emit();
	}
}
